var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex w-full h-full bg-primary-200"},[_c('div',{staticClass:"h-full transition-all duration-400 ease-in-out",style:({'background-color': _vm.waveColor, width: (_vm.progress + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }